import { getDateFromStringWithoutTime } from '@/lib/date'

const mapperCareerInTheMarketToApi = (form, user_id) => {
    const { companyName, area, office, start, end, mainActivities } = form

    return {
        company_name: companyName,
        area,
        office,
        start: getDateFromStringWithoutTime(start, 'YYYY-MM-DD'),
        end: getDateFromStringWithoutTime(end, 'YYYY-MM-DD'),
        main_activities: mainActivities,
        user_id: user_id,
    }
}

export { mapperCareerInTheMarketToApi }
